import { tss } from 'tss-react';

export const useStyles = tss.create({
  wrapper: {
    display: 'flex',
    alignItems: 'center' // Keep center alignment for the wrapper
  },
  tooltipSpan: {
    display: 'inline-flex',
    alignItems: 'center', // Vertically center the icon within the span
    marginLeft: '4px', // Add some space between checkbox text and icon
    marginBottom: '5px' // Add margin below the tooltip icon if needed for alignment
  }
  // Add other styles if needed based on Checkbox component structure
});
